// extracted by mini-css-extract-plugin
export default {"CompetitionNotes__Wrapper":"CompetitionNotes_CompetitionNotes__Wrapper__FblyZ","CompetitionNotes__TextArea":"CompetitionNotes_CompetitionNotes__TextArea__53t9P"};